export { DOMAIN_NAME } from '../common';

const MY_TIMESHEET_ROUTE = 29;

export { MY_TIMESHEET_ROUTE };
